export const colors = {
  primary: '#2a4095',
  textGrey: '#1C1C1C',
  redDark: '#c74040',
  secondarySharp: '#00b3e8',
  secondarySharpDark: '#78a22f',
  text: '#010303',
  offwhite: '#ffffff',
}
